// UserClaimsPopup.jsx
import React, { useEffect, useState } from 'react';
import { Modal, Button, Row, Col, Card, Image } from '@themesberg/react-bootstrap';
import { AllClaims } from './AllClaims';
import { useTranslation } from 'react-i18next';
import API from "../../utils/api";

export default function SingleUserAllClaims({ user, show, onClose }) {
  const { t } = useTranslation();

  const [mandateFile, setMandateFile] = useState(null);

  // Fetch mandate when popup opens
  useEffect(() => {
    if (user?.userId) {
      fetchMandate(user.userId);
    }
  }, [user]);

  const fetchMandate = async (userId) => {
    try {
      const res = await API.get(`/claims/mandate/${userId}`);
      setMandateFile(res.data.mandateFile || null);
    } catch (error) {
      console.error("Failed to fetch mandate:", error);
    }
  };

  if (!user) return null;

  const profileFields = [
    { label: t('singleUserAllClaimsTranslations.labels.fullName'), value: user.fullName },
    { label: t('singleUserAllClaimsTranslations.labels.email'), value: user.email },
    { label: t('singleUserAllClaimsTranslations.labels.phone'), value: user.phone },
    { label: t('singleUserAllClaimsTranslations.labels.address'), value: user.address },
    { label: t('singleUserAllClaimsTranslations.labels.companyName'), value: user.companyName },
    {
      label: t('singleUserAllClaimsTranslations.labels.eligibility'),
      value: user.eligibility
        ? t('singleUserAllClaimsTranslations.values.yes')
        : t('singleUserAllClaimsTranslations.values.no')
    },
    { label: t('singleUserAllClaimsTranslations.labels.userType'), value: user.userType },
  ];

  return (
    <Modal show={show} onHide={onClose} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {t('singleUserAllClaimsTranslations.profileTitle', {
            fullName: user.fullName || t('singleUserAllClaimsTranslations.values.no')
          })}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ padding: '20px' }}>
        <Card className="modern-profile-card mb-4">
          <Row className="align-items-center">
            {/* Profile Picture */}
            <Col xs={12} md={3} className="text-center mb-3 mb-md-0">
              {user.profilePicture ? (
                <Image
                  src={`https://api-dashboard.nordmann-inkasso.de/${user.profilePicture.replace(/\\/g, '/')}`}
                  roundedCircle
                  width={120}
                  height={120}
                  alt={user.fullName}
                  className="profile-avatar"
                />
              ) : (
                <div className="profile-avatar-placeholder">
                  {user.fullName ? user.fullName[0] : 'U'}
                </div>
              )}
            </Col>

            {/* Profile Info */}
            <Col xs={12} md={9}>
              <Row>
                {profileFields.map(
                  (field, idx) =>
                    field.value && (
                      <Col xs={12} md={6} className="mb-3" key={idx}>
                        <div className="profile-field">
                          <span className="field-label">{field.label}</span>
                          <span className="field-value">{field.value}</span>
                        </div>
                      </Col>
                    )
                )}
              </Row>

              {/* Mandate Section */}
              <div className="mt-3">
                <h6>{t("MandateLable")}</h6>
                {mandateFile ? (
                  <a
                    href={`https://api-dashboard.nordmann-inkasso.de/${mandateFile.replace(/\\/g, "/")}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-sm btn-outline-primary mt-2"
                  >
                    {t("yesMandate")}
                  </a>
                ) : (
                  <p className="text-muted">{t("noMandate")}</p>
                  
                )}
              </div>
            </Col>
          </Row>
        </Card>

        {/* User claims section */}
        <AllClaims userId={user.userId} />
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          {t('singleUserAllClaimsTranslations.buttons.close')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
